import { render, staticRenderFns } from "./TicketComments.vue?vue&type=template&id=bd1a8702&"
import script from "./TicketComments.vue?vue&type=script&lang=ts&"
export * from "./TicketComments.vue?vue&type=script&lang=ts&"
import style0 from "./TicketComments.vue?vue&type=style&index=0&id=bd1a8702&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports